<div class="main ">
    <div class="bottom-decor"></div>
    <header class="main__header">
        <div class="main__card card">
            <div class="card__icon"></div>
            <h1 class="card__title">Сервис</h1>
            <p class="card__description">вступительных и переводных<br>испытаний спортсменов</p>
        </div>
    </header>
    <main class="main__main">
          <div class="access-denied">
              <div class="item__icon">
                  <mat-icon style="color: red;">warning</mat-icon>
              </div>
              <div class="item__name">Доступ запрещен</div>
              <a href="/">Вернуться на главную</a>
          </div>
    </main>
</div>
